import React, { useEffect, useMemo, useState } from "react";
import Button from "components/Button";
import { Template } from "layouts/Template";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MathGame from "pages/home/components/MathPage";
import Finish from "pages/home/components/Finish";
import {
  useAddDiagnostiqueEleveTentativeMutation,
  useGetEpreuvexByDiagnostiqueQuery,
} from "redux_dir/features/diagnostiqueApi";
import useGetUserInfo from "hooks/useGetUserInfo";
import { useGetDiagnostiqueWithNiveauxQuery } from "redux_dir/features/parentApi";
import { useDispatch } from "react-redux";
import {
  setEpreuveNote,
  setEscoreNiveau,
} from "redux_dir/features/diagnostiqueSlice";
import useQuery from "components/useQuery";
import { useSelector } from "react-redux";
import { useGetEleveQuery } from "redux_dir/features/eleveApi";
import { progressImage } from "utils/images";
import Loader from "components/Loader";
import { getNumber } from "utils/soted";
import { compareText, correctFigure, normalizeFrenchNumber } from "utils/comparentText";
import { getCurrentEleve, setTentatives } from "redux_dir/features/eleveSlice";
import { toast } from "sonner";
import { arraysAreEqual } from "utils/Array";
import * as mathjs from 'mathjs';
import Analytics from "utils/analytics";
import axios from "axios";
import CorrectionFeedbackModal from "./CorrectionFeedbackModal";
import { getTokenFallback } from "redux_dir/features/apiMananger";
import { API_URL } from "routes/api";
import { setIncreaseCredit, getParentForm, setParentForm } from "redux_dir/features/parentSlice";
import { useUpdateParentMutation } from "redux_dir/features/parentApi";
import { ENABLE_CREDIT_SYSTEM } from "constants";
import {
  trackDiagnosticProgress,
  trackDiagnosticNiveauSuivant,
  trackDiagnosticCompleted,
} from "utils/diagnosticTracking";

function ExerciceMathPage() {
  const params = useParams();
  const navigation = useNavigate();
  const location = useLocation();
  const searchParams = useQuery();

  const diagnostiqueStore = useSelector(
    (state) => state?.user?.diagnostiqueReducer
  );

  const studentDemo = useSelector(getCurrentEleve);

  // useEffect(() => {
  //   console.log({ diagnostiqueStore });
  // }, []);

  const dispatch = useDispatch();

  const { csrfToken } = useGetUserInfo();
  const tokenFromStore = useSelector(
    (state) => state?.user?.userReducer?.userInfo?.token
  );

  const { data: datas } = useGetEpreuvexByDiagnostiqueQuery(
    parseInt(params.id)
  );

  const { data: eleve } = useGetEleveQuery(params?.eleveId);

  const { data: diagnostiqueNiveauxData, isLoading } =
    useGetDiagnostiqueWithNiveauxQuery(parseInt(params.id));
  const [diagnostiqueNiveaux, setDiagnostiqueNiveaux] = useState({});
  // console.log(diagnostiqueNiveauxData, "ddddddddddddddddddd")
  const [addDiagnostiqueEleveTentative, { isLoading: addLoading }] =
    useAddDiagnostiqueEleveTentativeMutation();

  const [currentLevel, setCurrentLevel] = useState(
    parseInt(searchParams.get("niveau")) ?? 0
  );

  const [current, setCurrent] = useState(
    parseInt(searchParams.get("epreuve")) ?? 0
  );

  const [selected, setSelected] = useState([]);
  const [end, setEnd] = useState(false);
  const [userAnswer, setUserAnswer] = useState(null);
  const [result] = useState(false);
  const [textRecorded, setTextRecorded] = useState("");

  const [selecteFigure, onSelecteFigure] = useState("");
  const [savedDiagnosticId, setSavedDiagnosticId] = useState(null);
  // Correction IA détaillée affichée avant de passer à l'exercice suivant
  const [pendingFeedback, setPendingFeedback] = useState(null);

  /**
   * Ajout de l'element cliquer dans le tableau
   * @param {*} value
   */
  const handleAddWord = (value) => {
    if (!selected.includes(value)) {
      setSelected([...selected, value])
    } else {
      setSelected(selected.filter((item) => item !== value))
    }
    if (diagnostiqueNiveaux?.data[currentLevel]?.data[current]?.type === "od") {
      setUserAnswer([...selected, value]); // Store the updated selection in userAnswer
    }
  };

  useEffect(() => {
    if (diagnostiqueNiveaux.data) {
      console.log('====================================');
      console.log({ selected });
      console.log({ completDiagnostic: diagnostiqueNiveaux.data });
      const levelExercices = diagnostiqueNiveaux?.data[currentLevel]?.data
      console.log({ levelExercices });
      // console.log({ currentExercice: levelExercices[current] });

      console.log({ diagnostiqueNiveaux });
      console.log('====================================');
    }
  }, [selected?.length, diagnostiqueNiveaux]);

  /**
   *
   * @param {string} value
   */
  const handleRemoveWord = (value) => {
    selected.includes(value) &&
      setSelected(selected.filter((item) => item !== value));
  };

  const resetAnswers = () => {
    setUserAnswer(null);
    setSelected([]);
    setTextRecorded("");
    onSelecteFigure([]);
  };

  /**
   * Comparaison de deux tableaux
   * @param {*} tableau1
   * @param {*} tableau2
   * @returns
   */
  function isEqual(tableau1, tableau2) {
    if (tableau1?.length !== tableau2?.length) return false;

    return tableau1.every((value, index) => value === tableau2[index]);
  }

  /**
   * Go next exercice
   * @returns
   */
  // console.log("diagnostiqueNiveaux: ", diagnostiqueNiveaux);
  // console.log("currentLevel: ", currentLevel);
  // console.log("current: ", current);

  const userAnswerAsStrings = userAnswer?.map(String);
  console.log(userAnswerAsStrings);
  const advanceToNext = (note, studentResponseValue) => {
    const currentExercise =
      diagnostiqueNiveaux?.data[currentLevel]?.data[current];
    try {
      // Save the current exercise's note
      dispatch(setEscoreNiveau(note));
      dispatch(
        setEpreuveNote({
          epreuveId: currentExercise?.id,
          note: Math.round(note),
          niveau: diagnostiqueNiveaux?.data[currentLevel]?.niveau,
          response: studentResponseValue,
        })
      );

      // Prepare for the next exercise
      const nextIndex = current + 1;
      const isLastExercise =
        nextIndex === diagnostiqueNiveaux?.data[currentLevel]?.data?.length;

      trackDiagnosticProgress({
        matiere: "MATHEMATIQUE",
        eleveId: studentDemo?.id,
        diagnosticId: params?.id,
        niveau: diagnostiqueNiveaux?.data[currentLevel]?.niveau,
        typeExercice: currentExercise?.type,
        question: current + 1,
        totalQuestions: diagnostiqueNiveaux?.data[currentLevel]?.data?.length,
        note: Math.round(note),
        bareme: currentExercise?.bareme,
        derniereQuestionDuNiveau: isLastExercise,
      });

      if (isLastExercise) {
        // Redirect to the results page or finish component
        setEnd(true);

        // If it's the last level, save immediately in background for instant redirect
        if (diagnostiqueNiveaux?.data?.length === currentLevel + 1) {
          saveDiagnosticInBackground();
        }
      } else {
        // Navigate to the next exercise
        navigation(`?niveau=${currentLevel}&epreuve=${nextIndex}`, { replace: true });

        // Reset state for the new exercise
        setUserAnswer(null);
        setSelected([]);
        setTextRecorded("");
        onSelecteFigure([]);
      }
    } catch (error) {
      console.error("Erreur lors du passage à l'exercice suivant :", error);
    }
  };

  const handleNext = async () => {
    // Add Mixpanel tracking for Valider button
    Analytics.trackValiderButton('Math Exercise', 'Math');

    const currentExercise =
      diagnostiqueNiveaux?.data[currentLevel]?.data[current];
    console.log("currentExercise: ", currentExercise);
    const correctAnswer = currentExercise?.correction_dp;

    let note = 0;
    let evaluation = null;
    // Normaliser la réponse de l'élève en string (avant le reset des réponses)
    const studentResponseValue = userAnswer?.length > 0
      ? userAnswer.join(" ")
      : selected?.length > 0
        ? selected.join(" ")
        : textRecorded || null;
    //  reset the answers
    resetAnswers();
    // WIN : Word in Number
    // WIL : Word in letter
    if (currentExercise?.type === "win" || currentExercise?.type === "wil") {
      note = compareText(
        textRecorded.split(",").join(" ").toLowerCase(),
        currentExercise.correction_dp.join(" ").toLowerCase(),
        currentExercise.bareme
      )?.score;
    } else if (currentExercise?.type === "figure") {
      // return console.log({selecteFigure});

      note = correctFigure(
        selecteFigure.join(" "),
        currentExercise?.correction_dp.join(" "),
        currentExercise?.bareme
      );
    } else if (currentExercise?.type === "od" || currentExercise?.type === "oc") {
      // Convert userAnswer to strings for comparison
      const userAnswerAsStrings = userAnswer?.map(String);

      // Check for empty answers
      if (userAnswerAsStrings.includes("")) {
        toast.warning("Veuillez compléter tous les champs de réponse."); // Show warning toast in French
        return; // Exit the function if there are empty answers
      }

      const isCorrect = arraysAreEqual(userAnswerAsStrings, correctAnswer);

      if (isCorrect) {
        note = currentExercise?.bareme; // Give full score if the answer is correct
        console.log("Answer is Correct. Note:", note);
      }
      else {
        console.log("Answer is Incorrect.");
      }
    } else if (currentExercise?.type === "numberToWords") {

      if (Array.isArray(userAnswer) && userAnswer.length > 0) {
        const isCorrect = userAnswer.every(
          (answer, index) => normalizeFrenchNumber(answer) === normalizeFrenchNumber(correctAnswer[index])
        );
        if (isCorrect) {
          note = currentExercise?.bareme;
        } else {
          console.log("Answer is Incorrect.");
        }
      } else {
        console.log("User Answer is empty or invalid.");
      }
    } else if (currentExercise?.type === "wordToNumbers" || currentExercise?.type === "numberDictation" || currentExercise?.type === "completerEnonces") {

      if (Array.isArray(userAnswer) && userAnswer.length > 0) {
        const isCorrect = userAnswer.every(
          (answer, index) => String(answer).toLowerCase() === String(correctAnswer[index]).toLowerCase()
        );
        if (isCorrect) {
          note = currentExercise?.bareme;
        } else {
          console.log("Answer is Incorrect.");
        }
      } else {
        console.log("User Answer is empty or invalid.");
      }
    } else if (currentExercise?.type === "resolutionProbleme") {
      // For resolutionProbleme, we validate the answers directly here
      if (Array.isArray(userAnswer) && userAnswer.length > 0) {
        try {
          // Create request payload
          const requestPayload = {
            problem: currentExercise.consigne[0],
            student_answer: userAnswer.join("; ")
          };
          console.log("Sending to API:", requestPayload);

          // Make API request to validate answers
          // correct/ exige un JWT : sans lui le backend répond 401
          const bearer = tokenFromStore || getTokenFallback();
          const response = await axios.post(`${API_URL}correct/`, requestPayload, {
            headers: bearer ? { Authorization: `Bearer ${bearer}` } : {},
          });

          if (response.data) {
            const { success_rate, found, feedback } = response.data;
            evaluation = response.data.evaluation || null;
            console.log("API Response:", { success_rate, found, feedback });

            // Calculate the score based on success_rate
            if (found === "True" && success_rate) {
              const successRate = parseInt(success_rate);
              note = (currentExercise?.bareme * successRate) / 100;
              console.log("Success rate:", successRate);
              console.log("Calculated note:", note);

              // Show appropriate toast based on success rate
              if (!evaluation) {
                if (successRate === 100) {
                  toast.success("Bravo! Votre solution est correcte.");
                } else {
                  toast.info("Votre solution peut être améliorée.");
                }
              }
            } else {
              console.log("Answer not found or invalid success rate");
              if (!evaluation) {
                toast.warning("Votre réponse n'est pas correcte.");
              }
            }
          }
        } catch (error) {
          console.error("Error validating answers:", error);
          toast.error("Erreur lors de la validation de vos réponses.");
        }
      } else {
        console.log("User Answer is empty or invalid.");
        toast.warning("Veuillez entrer au moins une réponse.");
      }
    } else if (currentExercise.type === "missingNumbers") {
      // Ensure both arrays are of the same length
      if (Array.isArray(userAnswer) && userAnswer.length === correctAnswer.length) {
        const isCorrect = userAnswer.every((answer, index) => {
          const userValue = Number(answer);
          const correctValue = Number(correctAnswer[index]);
          return userValue === correctValue;
        });

        if (isCorrect) {
          note = currentExercise?.bareme;
        }
      } else {
        console.log(
          "User Answer length does not match the correct answer length."
        );
      }
    } else if (currentExercise.type === "operation") {
      console.log("Operation userAnswer: ", userAnswer);
      console.log("Operation correction: ", correctAnswer);

      // Pour les opérations, comparer les valeurs numériques avec une tolérance
      let isCorrect = false;

      if (userAnswer && correctAnswer && userAnswer.length === correctAnswer.length) {
        isCorrect = userAnswer.every((answer, index) => {
          const userValue = parseFloat(answer);
          const correctValue = parseFloat(correctAnswer[index]);

          // Tolérance de 0.01 pour l'arrondi
          const tolerance = 0.01;
          const difference = Math.abs(userValue - correctValue);
          return difference <= tolerance;
        });
      }

      console.log("Operation isCorrect: ", isCorrect);
      if (isCorrect) {
        note = currentExercise?.bareme;
        console.log("Answer is Correct. Note:", note);
      } else {
        console.log("Answer is Incorrect.");
      }
    }
    else {
      console.log("Type: Words to Numbers/Letters");
      console.log("User Answer (userAnswer):", userAnswer);
      if (selected?.length > 0 || textRecorded || userAnswer) {
        if (isEqual(correctAnswer, !userAnswer ? selected : [userAnswer])) {
          note = currentExercise?.bareme;
        }
      }
    }

    if (evaluation) {
      // Laisse l'élève lire la correction avant de continuer
      setPendingFeedback({ evaluation, note, studentResponseValue });
      return;
    }
    advanceToNext(note, studentResponseValue);
  };

  // Custom evaluation function to handle expressions with 'x' as multiplication
  function evaluateExpression(expression) {
    const [operand1, operator, operand2] = expression?.split(/(\+|\-|\*|\x|\/|=)/);

    if (!operand1 || !operator || !operand2) {
      throw new Error('Invalid expression format');
    }

    switch (operator) {
      case '+':
        return Number(operand1) + Number(operand2);
      case '-':
        return Number(operand1) - Number(operand2);
      case '*':
      case 'x':
        return Number(operand1) * Number(operand2);
      case '/':
        return Number(operand1) / Number(operand2);
      default:
        throw new Error(`Invalid operator: ${operator}`);
    }
  }

  const checkAnswer = (value) => { };

  const handleCheck = (value) => {
    setUserAnswer(value);
  };

  /**
   * Filtrer les diagnostics par niveaux
   */
  useMemo(() => {
    if (diagnostiqueNiveauxData) {
      setDiagnostiqueNiveaux({
        ...diagnostiqueNiveaux,
        count: diagnostiqueNiveauxData?.count,
        data: [...diagnostiqueNiveauxData?.data].sort(
          (a, b) => getNumber(a.niveau) - getNumber(b.niveau)
        ),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diagnostiqueNiveauxData]);

  /**
   * Mettre a jour le niveau et l'exercice courrant
   */
  useMemo(() => {
    setCurrentLevel(parseInt(searchParams.get("niveau")));
    setCurrent(parseInt(searchParams.get("epreuve")));
  }, [searchParams]);

  const formParent = useSelector(getParentForm);
  const [updateParentCredit] = useUpdateParentMutation();

  /**
   * Save diagnostic in background for instant redirect
   */
  const saveDiagnosticInBackground = async () => {
    try {
      const { score: scoreNiveau, ...res } = diagnostiqueStore;

      const notes = res?.notes.map((note) => ({
        epreuveId: note?.epreuveId,
        note: note?.note,
        response: note?.response ?? null,
      }));

      const response = await addDiagnostiqueEleveTentative({
        body: {
          ...res,
          notes,
          status: "VALIDE",
          diagnosticId: parseInt(params.id),
        },
        token: csrfToken,
      });

      if (!response?.error && response?.data?.id) {
        setSavedDiagnosticId(response.data.id);

        // Update Redux state
        dispatch(
          setTentatives({
            diagnostique: diagnostiqueStore,
            eleveId: studentDemo?.id,
            diagnosticId: response.data.id,
            type: "MATHEMATIQUE",
            createdAt: new Date(Date.now()),
          })
        );

        trackDiagnosticCompleted({
          matiere: "MATHEMATIQUE",
          eleveId: studentDemo?.id,
          diagnosticId: params?.id,
          tentativeId: response.data.id,
          statut: "VALIDE",
          scoreTotal: diagnostiqueStore?.score,
          nombreNiveaux: diagnostiqueNiveaux?.data?.length,
          creditsRestants: formParent?.credits,
        });

        // --- Déduction de crédits (désactivable via ENABLE_CREDIT_SYSTEM) ---
        if (ENABLE_CREDIT_SYSTEM && formParent?.credits > 0) {
          updateParentCredit({
            parentId: formParent?.id,
            credits: formParent?.credits - 25,
          })
            .then((resStatus) => {
              if (resStatus?.data) {
                dispatch(setIncreaseCredit());
                dispatch(
                  setParentForm({
                    ...formParent,
                    credits: resStatus?.data?.data?.credits,
                  })
                );
              }
            })
            .catch((creditError) => {
              console.error("Error updating credits:", creditError);
            });
        }
      }
    } catch (error) {
      console.error("Error saving diagnostic in background:", error);
    }
  };

  /**
   * Passage de niveau
   * @returns
   */
  const handleContinueNextLevel = async (forceAnalyse = false) => {
    // If user failed and we must go directly to analysis page
    if (forceAnalyse) {
      try {
        const { score: scoreNiveau, ...res } = diagnostiqueStore;
        const notes = res?.notes.map((note) => ({
          epreuveId: note?.epreuveId,
          note: note?.note,
          response: note?.response ?? null,
        }));

        // --- Déduction de crédits (désactivable via ENABLE_CREDIT_SYSTEM) ---
        if (ENABLE_CREDIT_SYSTEM && formParent?.credits > 0) {
          updateParentCredit({
            parentId: formParent?.id,
            credits: formParent?.credits - 25,
          })
            .then((resStatus) => {
              if (resStatus?.data) {
                dispatch(setIncreaseCredit());
                dispatch(
                  setParentForm({
                    ...formParent,
                    credits: resStatus?.data?.data?.credits,
                  })
                );
              }
            })
            .catch((creditError) => {
              console.error("Error updating credits:", creditError);
            });
        }

        const response = await addDiagnostiqueEleveTentative({
          body: {
            ...res,
            notes,
            status: "ENCOURS",
            diagnosticId: parseInt(params.id),
          },
          token: csrfToken,
        });

        // La sauvegarde a échoué (ex: 400) : on reste sur la page au lieu de planter
        if (response?.error || !response?.data?.id) {
          console.error("Error saving incomplete diagnostic:", response?.error);
          toast.error("Erreur lors de la sauvegarde de la tentative.");
          return;
        }

        setEnd(true);
        navigation(`../analyse/${response.data.id}?analyseIncomplete=true`, { replace: true });

        if (!response?.error && response?.data?.id) {
          dispatch(
            setTentatives({
              diagnostique: diagnostiqueStore,
              eleveId: studentDemo?.id,
              diagnosticId: response.data.id,
              type: "MATHEMATIQUE",
              createdAt: new Date(Date.now()),
            })
          );

          trackDiagnosticCompleted({
            matiere: "MATHEMATIQUE",
            eleveId: studentDemo?.id,
            diagnosticId: params?.id,
            tentativeId: response.data.id,
            statut: "ENCOURS",
            scoreTotal: diagnostiqueStore?.score,
            nombreNiveaux: diagnostiqueNiveaux?.data?.length,
            creditsRestants: formParent?.credits,
          });

          // Navigate directly to analysis page
          setEnd(false);
          navigation(`../analyse/${response.data.id}`, { replace: true });
          return;
        } else {
          toast.error("Erreur lors de la sauvegarde de la tentative.");
        }
      } catch (error) {
        console.error("Error forcing analysis redirect:", error);
        toast.error("Erreur lors de la redirection vers l'analyse.");
        return;
      }
    }
    // Last level - instant redirect if already saved
    if (diagnostiqueNiveaux?.data?.length === currentLevel + 1) {
      // If already saved in background, redirect immediately
      if (savedDiagnosticId) {
        setEnd(false);
        navigation(`../analyse/${savedDiagnosticId}`, {
          replace: true,
        });
        return;
      }

      // Fallback: save now if not already done
      try {
        const { score: scoreNiveau, ...res } = diagnostiqueStore;

        const notes = res?.notes.map((note) => ({
          epreuveId: note?.epreuveId,
          note: note?.note,
          response: note?.response ?? null,
        }));

        const response = await addDiagnostiqueEleveTentative({
          body: {
            ...res,
            notes,
            status: "VALIDE",
            diagnosticId: parseInt(params.id),
          },
          token: csrfToken,
        });

        if (response?.error) {
          toast.error("Erreur lors de l'enregistrement. Veuillez réessayer.");
          return;
        }

        // Update Redux state
        dispatch(
          setTentatives({
            diagnostique: diagnostiqueStore,
            eleveId: studentDemo?.id,
            diagnosticId: response?.data?.id,
            type: "MATHEMATIQUE",
            createdAt: new Date(Date.now()),
          })
        );

        trackDiagnosticCompleted({
          matiere: "MATHEMATIQUE",
          eleveId: studentDemo?.id,
          diagnosticId: params?.id,
          tentativeId: response?.data?.id,
          statut: "VALIDE",
          scoreTotal: diagnostiqueStore?.score,
          nombreNiveaux: diagnostiqueNiveaux?.data?.length,
          creditsRestants: formParent?.credits,
        });

        // --- Déduction de crédits (désactivable via ENABLE_CREDIT_SYSTEM) ---
        if (ENABLE_CREDIT_SYSTEM && formParent?.credits > 0) {
          updateParentCredit({
            parentId: formParent?.id,
            credits: formParent?.credits - 25,
          })
            .then((resStatus) => {
              if (resStatus?.data) {
                dispatch(setIncreaseCredit());
                dispatch(
                  setParentForm({
                    ...formParent,
                    credits: resStatus?.data?.data?.credits,
                  })
                );
              }
            })
            .catch((creditError) => {
              console.error("Error updating credits:", creditError);
            });
        }

        // Navigate to analysis page
        setEnd(false);
        navigation(`../analyse/${response?.data?.id}`, {
          replace: true,
        });
      } catch (error) {
        console.error("Error in handleContinueNextLevel:", error);
        toast.error("Une erreur est survenue. Veuillez réessayer.");
      }
    } else {
      // Move to next level
      trackDiagnosticNiveauSuivant({
        matiere: "MATHEMATIQUE",
        eleveId: studentDemo?.id,
        diagnosticId: params?.id,
        niveauSuivant: diagnostiqueNiveaux?.data[currentLevel + 1]?.niveau,
      });
      setEnd(false);
      navigation(`?niveau=${currentLevel + 1}&epreuve=${0}`, {
        replace: true,
      });
    }
  };
  // console.log("currentLevel", currentLevel)
  // console.log("diagnostiqueNiveaux", diagnostiqueNiveaux?.data)

  return isLoading ? (
    <div className="h-[100dvh] w-full flex flex-col justify-center items-center">
      <Loader />
      <p>Chargement des exercices...</p>
    </div>
  ) : diagnostiqueNiveauxData?.count === 0 ? (
    <div className="h-[100dvh] w-full flex justify-center items-center flex-col gap-4">
      <p>Aucune question pour le moment</p>
      <Button radius={"md"} onClick={() => navigation(-1)}>
        retour
      </Button>
    </div>
  ) : (
    <Template
      footer={
        end || location.state?.end ? null : (
          <div
            style={{
              display: "flex",
              gap: 10,
              padding: "0 10px",
              marginTop: 5,
            }}
          >
            {diagnostiqueNiveaux?.count === 0 ? (
              <Button
                onClick={() => navigation(-1, { replace: true })}
                style={{ width: "100%" }}
                radius={"md"}
              >
                Retour
              </Button>
            ) : (
              !end && (
                <Button
                  onClick={handleNext}
                  style={{ width: "100%" }}
                  radius={"md"}
                  disabled={
                    userAnswer !== null ||
                      selected?.length > 0 ||
                      textRecorded ||
                      selecteFigure?.length > 0
                      ? false
                      : true
                  }
                >
                  Valider
                </Button>
              )
            )}
          </div>
        )
      }
    >
      <CorrectionFeedbackModal
        evaluation={pendingFeedback?.evaluation}
        onContinue={() => {
          const { note, studentResponseValue } = pendingFeedback;
          setPendingFeedback(null);
          advanceToNext(note, studentResponseValue);
        }}
      />
      {/* Word quizz */}
      {datas?.count === 0 ? (
        "Pas d'exercice"
      ) : end || location.state?.end ? (
        <div
          className=""
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {isLoading || !diagnostiqueNiveaux?.data ? (
            <Loader />
          ) : (
            <Finish
              data={diagnostiqueNiveaux?.data[currentLevel]}
              globalNote={diagnostiqueNiveaux?.data[currentLevel]?.data?.reduce(
                (acc, cur) => acc + cur?.bareme,
                0
              )}
              score={diagnostiqueStore?.notes
                .filter(
                  (note) =>
                    note?.niveau ===
                    diagnostiqueNiveaux?.data[currentLevel]?.niveau
                )
                .reduce((acc, curr) => acc + curr?.note, 0)}
              // note={diagnostiqueStore?.score}
              note={diagnostiqueStore?.notes
                ?.filter(
                  (note) =>
                    String(note?.niveau) ===
                    String(diagnostiqueNiveaux?.data[currentLevel]?.niveau)
                )
                ?.reduce((acc, curr) => acc + (curr?.note || 0), 0)}
              onRestart={() => window.location.reload()}
              seuil={diagnostiqueNiveaux?.data[currentLevel]?.seuil}
              onQuit={async () => {
                // return console.log({diagnostiqueStore});
                try {
                  await addDiagnostiqueEleveTentative({
                    body: { ...diagnostiqueStore },
                    token: csrfToken,
                  });
                  // console.log({ res });
                  navigation("/" + params?.eleveId + "/matiere", {
                    replace: true,
                  });
                } catch (error) {
                  console.log({ error });
                }
              }}
              onCountinue={handleContinueNextLevel}
              loading={addLoading}
              finish={
                diagnostiqueNiveaux?.data?.length === currentLevel + 1
              }
            />
          )}
        </div>
      ) : (
        <MathGame
          // TODO: rename data to completDiagnostic
          completDiagnostic={diagnostiqueNiveaux && diagnostiqueNiveaux?.data ? diagnostiqueNiveaux?.data : []}
          eleve={eleve}
          studentDemo={studentDemo}
          userAnswer={userAnswer}
          setUserAnswer={setUserAnswer}
          currentLevel={currentLevel}
          current={current}
          selected={selected}
          result={result}
          handleCheck={handleCheck}
          checkAnswer={checkAnswer}
          handleAddWord={handleAddWord}
          handleRemoveWord={handleRemoveWord}
          randomeImage={progressImage[currentLevel]}
          handleGoBack={() => navigation(-1)}
          textRecorded={textRecorded}
          onTextRecorded={setTextRecorded}
          // Figure
          onSelecteFigure={onSelecteFigure}
        />
      )}
    </Template>
  );
}

export default ExerciceMathPage;
